import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import _ from "lodash";
import Alert from "shared/components/alert";
import Button from "shared/components/Button";
import { setIsLoading } from "redux/loader/action";
import { set_password_reset_details } from "redux/signin/action";
import signinLogo from "assets/images/signin/logo.png";
import mailInbox from "assets/images/signin/mail-inbox.png";
import enterCode from "assets/images/signin/enter-code.png";
import resetSuccess from "assets/images/signin/reset-success.png";
import resetFailure from "assets/images/signin/reset-failure.png";
import InputCodeContainer from "./components/InputCodeContainer";

const PasswordReset = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const password_reset_details = useSelector(
    (state) => state.signinReducer.password_reset_details
  );
  const login_params = useSelector(
    (state) => state.paramsReducer.paramsObj.app.screens_v2.login
  );
  const password_reset_params = useSelector(
    (state) => state.paramsReducer.paramsObj.app.screens_v2.forgot_password
  );

  const tagline_text = _.get(login_params, "tagline_text", "Reset Password");
  const email_text = _.get(
    password_reset_params,
    "email_text",
    "Enter your email address and we will send you instructions to reset your password"
  );
  const email_hint = _.get(password_reset_params, "email_hint", "Your Email");
  const button_text = _.get(password_reset_params, "button_text", "Email Code");
  const terms_label = _.get(
    login_params,
    "terms_label",
    "By using heyLIME you agree to our "
  );
  const terms_text = _.get(login_params, "terms_text", "Terms");
  const terms_url = _.get(
    login_params,
    "terms_url",
    "https://gameapart-config.s3.amazonaws.com/common/terms.html"
  );
  const code_text = _.get(
    password_reset_params,
    "code_text",
    "Enter the code you received to reset your password."
  );
  const reset_button = _.get(
    password_reset_params,
    "reset_button",
    "Reset Password"
  );
  const error = _.get(
    password_reset_params,
    "error",
    "Please make sure your passwords match."
  );
  const failure_text = _.get(
    password_reset_params,
    "failure_text",
    "Code could not be verified. Try again."
  );
  const failure_button = _.get(
    password_reset_params,
    "failure_button",
    "Try Again"
  );
  const success_text = _.get(
    password_reset_params,
    "success_text",
    "Password changed successfully."
  );
  const success_button = _.get(
    password_reset_params,
    "success_button",
    "Login"
  );

  const { email, emailCode, resetPassword, signUp } = password_reset_details;
  const [termsModal, setTermsModal] = useState(false);
  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    code: "",
    password: "",
    confirm_password: ""
  });
  const [resetPasswordErrors, setResetPasswordErrors] = useState({
    code: "",
    password: "",
    confirm_password: ""
  });
  const codeDetailsEmpty = () =>
    resetPasswordDetails.code === "" ||
    resetPasswordDetails.password === "" ||
    resetPasswordDetails.confirm_password === "";

  const passwordMismatches = () =>
    resetPasswordDetails.confirm_password !== "" &&
    resetPasswordDetails.password !== resetPasswordDetails.confirm_password;

  const getApp = () => {
    window.open(`https://gameapart.app.link/fS3QgiWSdob`);
  };

  const handleIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };
  const handleInputChange = (value, name) => {
    console.log(value, name, "FHGHG");
    if (
      (name === "code" && value.length === 6) ||
      (name === "password" && value.length > 7) ||
      (name === "confirm_password" && !passwordMismatches(value))
    ) {
      setResetPasswordErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setResetPasswordDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendEmailCode = () => {
    const email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!email_regex.test(email)) {
      /*  dispatch(
        set_password_reset_details({
          ...password_reset_details,
          resetPassword: false
        })
      ); */
      Alert(400, "Please enter a valid email address.");
    } else {
      handleIsLoading(true);
      Auth.forgotPassword(email)
        .then((data) => {
          handleIsLoading(false);
          dispatch(
            set_password_reset_details({
              ...password_reset_details,
              emailCode: true
            })
          );
        })
        .catch((err) => {
          handleIsLoading(false);
          if (err.code === "UserNotFoundException") {
            /*  dispatch(
              set_password_reset_details({
                ...password_reset_details,
                resetPassword: false
              })
            ); */
            Alert(400, "User not found");
          }
          if (err.code === "LimitExceededException") {
            console.log("error", "call");

            Alert(400, err.message);
          }
        });
    }
  };

  const handleResetPassword = () => {
    console.log("handleResetPassword");
    let errorObj = { ...resetPasswordErrors };
    const { code, password } = resetPasswordDetails;
    console.log(password, password.length < 8, "<=====fgtht");
    if (code === "" || code.length !== 6)
      errorObj.code = "Code could not be verified. Try again.";
    if (password === "" || password.length < 8)
      errorObj.password = "Passwords must be 8 characters.";
    if (passwordMismatches())
      errorObj.confirm_password = "Passwords must be same.";
    if (
      errorObj.code === "" &&
      errorObj.password === "" &&
      errorObj.confirm_password === ""
    ) {
      handleIsLoading(true);
      Auth.forgotPasswordSubmit(email, code, password)
        .then((data) => {
          handleIsLoading(false);
          Alert(200, "Password changed successfully.");
          /*  dispatch(
          set_password_reset_details({
            ...password_reset_details,
            resetPassword: true
          })
        ); */
        })
        .catch((err) => {
          if (err.code.includes("Code")) {
            setResetPasswordErrors((prev) => ({
              ...prev,
              code: "Code could not be verified. Try again."
            }));
          }

          handleIsLoading(false);

          /*   dispatch(
          set_password_reset_details({
            ...password_reset_details,
            resetPassword: false
          })
        ); */
        });
    } else {
      setResetPasswordErrors(errorObj);
    }
  };

  const handleAfterReset = () => {
    if (resetPassword) {
      dispatch(
        set_password_reset_details({
          email: "",
          emailCode: false,
          resetPassword: null,
          signUp: false
        })
      );
      history.replace("/signin");
    } else {
      dispatch(
        set_password_reset_details({
          email: "",
          emailCode: false,
          resetPassword: null,
          signUp: true
        })
      );
    }
    // Alert(400, err.message);
  };
  const backToLogin = () => {
    history.replace("/signin");
  };

  console.log("resetPassword==>", resetPassword);
  return (
    <div className="signin-container">
      <div className="top-container">
        <div className="auth-bg"></div>
        <img alt="" src={signinLogo} className="signin-logo" />
        {/* <h2 className="signin-heading">{tagline_text}</h2> */}
        <h2 className="auth-heading">
          {resetPassword === null && !emailCode
            ? "Forgot Password"
            : "Reset Password "}
        </h2>
        {resetPassword === null && !emailCode ? (
          <>
            {/* <img alt="" src={mailInbox} className="mail-inbox" /> */}
            <p className="forgot-txt">
              Enter your email address and we will send you instructions to
              reset your password
            </p>
            <div className="input-container password-reset">
              <input
                name="email"
                type="email"
                value={email}
                className="input-div"
                placeholder={email_hint}
                onChange={(e) =>
                  dispatch(
                    set_password_reset_details({
                      ...password_reset_details,
                      email: e.target.value
                    })
                  )
                }
              />
            </div>
            <Button
              text={"Continue"}
              class_name="email-code"
              onPress={handleSendEmailCode}
            />
            <p className="rem-txt">
              Remembered your password?
              <span onClick={() => backToLogin()}>Back to Log In</span>
            </p>
          </>
        ) : (
          <>
            {/* <h2 className="primary-text emailCode">{code_text}</h2> */}
            <h2 className="email-txt">
              Enter the code sent to your account’s email. The create your new
              password
            </h2>
            <InputCodeContainer
              errors={resetPasswordErrors}
              details={resetPasswordDetails}
              onInputChange={handleInputChange}
              password_reset_params={password_reset_params}
            />
            {/*  {passwordMismatches() && (
              <span className="password-mismatch">{error}</span>
            )} */}
            <Button
              text={reset_button}
              class_name="cont-btn"
              onPress={handleResetPassword}
            />
            <p className="rem-txt">
              Remembered your password? <span>Back to Log In</span>
            </p>
          </>
        )}
        {/*   <> 
          <img
            alt=""
            src={resetPassword ? resetSuccess : resetFailure}
            className="mail-inbox resetSuccess"
          />
          <h2 className="primary-text resetSuccess">
            {resetPassword ? success_text : failure_text}
          </h2>
          <Button
            onPress={handleAfterReset}
            class_name={resetPassword ? "" : "error"}
            text={resetPassword ? success_button : failure_button}
          />
      </> */}
      </div>
      <div style={{ paddingBottom: "14px" }}>
        <p className="heylime-bottom-text">Back to Home </p>
        <p className="heylime-bottom-text">
          © 2023 heyLIME. All rights reserved.
        </p>
      </div>
      {/* <p className="heylime-bottom-text">
        {terms_label}
        <span className="terms-text" onClick={() => setTermsModal(true)}>
          {terms_text}
        </span>
      </p> */}
      {termsModal && (
        <div className="invalid-code-modal terms">
          <div className="modal-inner terms">
            <iframe
              src={terms_url}
              className="terms-container"
              frameBorder="0"
            ></iframe>
            <button
              onClick={() => {
                setTermsModal(false);
              }}
              className="try-again-btn terms"
            >
              Okay, I got it!
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordReset;
